import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

import { ItemLandingService } from '../../services/item-landing.service';

@Component({
  selector: 'app-home-landing',
  templateUrl: './home-landing.component.html',
  styleUrls: ['./home-landing.component.scss'],
  standalone: false
})
export class HomeLandingComponent implements OnInit {
   constructor() { }

  ngOnInit(): void {
  }

}
